import { useTranslations } from 'next-intl';
import { Link } from '@mentimeter/ragnar-ui/link';
import { Text } from '@mentimeter/ragnar-ui/text';
import type { ReactNode } from 'react';
import { ErrorMessageWrapper } from './components/ErrorMessageWrapper';
import { ErrorMessageTitle } from './components/ErrorMessageTitle';

const MailingLink = (chunks: ReactNode) => (
  <Link href="mailto:support@mentimeter.com">{chunks}</Link>
);

const DownloadLink = (chunks: ReactNode) => (
  <Link href="/app/billing">{chunks}</Link>
);

export const UpgradeNotPossible = () => {
  const t = useTranslations('purchasing.legacy.checkoutUiPackage');

  return (
    <ErrorMessageWrapper>
      <ErrorMessageTitle text={t('errors.upgrade_not_possible')} />
      <Text textAlign="center" mt="space4" style={{ whiteSpace: 'pre' }}>
        {t.rich('errors.upgrade_not_possible_info', {
          mailToLink: MailingLink,
        })}{' '}
        {t.rich('errors.download_receipt_question', { download: DownloadLink })}
      </Text>
    </ErrorMessageWrapper>
  );
};
